export const COMETCHAT_CONSTANTS = {
	APP_ID: "2089113ea0e9f34e",
	REGION: "eu",
	AUTH_KEY: "94f95c3e493e75885c698903451cfc5a16c68a7b",
};
